import React, { useState, useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { useNavigate } from 'react-router-dom';

interface LoginProps {}

// Debug info interface - keeping for type safety but not displaying
interface DebugInfo {
  userState: any;
  localStorage: string | null;
  attemptingLogin?: boolean;
  username?: string;
  password?: string;
  loginSuccess?: boolean;
  loginError?: any;
}

const Login: React.FC<LoginProps> = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [debugInfo, setDebugInfo] = useState<DebugInfo>({
    userState: null,
    localStorage: null
  });
  const { login, loading, user } = useAuth();
  const navigate = useNavigate();
  
  // Check if user is already logged in and redirect if needed
  useEffect(() => {
    setDebugInfo(prev => ({ ...prev, userState: user, localStorage: localStorage.getItem('currentUser') }));
    
    if (user) {
      navigate('/family-tree');
    }
  }, [user, navigate]);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    
    if (!username || !password) {
      setError('Please enter both username and password');
      return;
    }
    
    try {
      setDebugInfo(prev => ({ ...prev, attemptingLogin: true, username, password }));
      const success = await login(username, password);
      setDebugInfo(prev => ({ ...prev, loginSuccess: success }));
      
      if (success) {
        navigate('/family-tree');
      } else {
        setError('Invalid username or password');
      }
    } catch (err) {
      console.error('Login error:', err);
      setDebugInfo(prev => ({ ...prev, loginError: err }));
      setError('An error occurred during login');
    }
  };

  return (
    <div className="login-container">
      <div className="login-form-container">
        <h1>Family Tree Application</h1>
        <h2>Login</h2>
        
        {error && <div className="error-message">{error}</div>}
        
        <form onSubmit={handleSubmit} className="login-form">
          <div className="form-group">
            <label htmlFor="username">Username</label>
            <input
              type="text"
              id="username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              disabled={loading}
            />
          </div>
          
          <div className="form-group">
            <label htmlFor="password">Password</label>
            <input
              type="password"
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              disabled={loading}
            />
          </div>
          
          <button type="submit" disabled={loading} className="login-button">
            {loading ? 'Logging in...' : 'Login'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default Login;
